import React from "react";
import { Box, Grid } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import TrafficShapingList from "../../components/TrafficShapingList";

function AITrafficShapingSources() {
  const { mdUp, lgUp } = useBreakpoints();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12}>
        <Box
          bgcolor="white"
          p={{ xs: 5, md: 6 }}
          borderRadius={mdUp ? "8px" : "0px"}
        >
          <TrafficShapingList />
        </Box>
      </Grid>
    </Grid>
  );
}

export default AITrafficShapingSources;
